const initialParentProps = {
  display: 'block',
  flexDirection: '',
  flexWrap: '',
  justifyContent: '',
  alignItems: '',
  alignContent: ''
}

const initialFlexItemProps = {
  order: '',
  flexGrow: '',
  flexShrink: '',
  flexBasis: '',
  alignSelf: ''
}

export const initialAppState = {
  parentProps: initialParentProps,
  flexItemProps: [initialFlexItemProps]
}

const globalReducer = (state, action) => {

  switch (action.type) {
    
    case 'FLEX-ITEM-ADD':
      return { 
        ...state, 
        flexItemProps: [...state.flexItemProps, initialFlexItemProps ] 
      };
    case 'FLEX-ITEM-REMOVE':
      let x = [...state.flexItemProps];
      x.pop();

      return {
        ...state,
        flexItemProps: x
      }
    case 'FLEX-ITEM-RESET':
      return {
        ...state,
        flexItemProps: []
      }
    
    case 'display':
      return {
        ...state,
        parentProps: {
          ...state.parentProps,
          display: action.payload
        }
      };
    case 'flex-direction':
      return {
        ...state,
        parentProps: {
          ...state.parentProps,
          flexDirection: action.payload
        }
      };
    case 'flex-wrap':
      return {
        ...state,
        parentProps: {
          ...state.parentProps,
          flexWrap: action.payload
        }
      };    
    case 'justify-content':
    return {
      ...state,
      parentProps: {
        ...state.parentProps,
        justifyContent: action.payload
      }
    };
    case 'align-items':
      return {
        ...state,
        parentProps: {
          ...state.parentProps,
          alignItems: action.payload
        }
      };
    case 'align-content':
      return {
        ...state,
        parentProps: {
          ...state.parentProps,
          alignContent: action.payload
        }
      };   
    case 'FLEX-PARENT-PROP-RESET':
      return {
        ...state,
        parentProps: initialParentProps
      }


    case 'order':
      let itemIdp = action.payload.itemId;

      let p = [...state.flexItemProps];

      p[itemIdp] = {
        ...p[itemIdp],
        order: action.payload.value
      }
  
      return {
        ...state,
        flexItemProps: p
      } 
    case 'flexGrow':
      let itemIdq = action.payload.itemId;

      let q = [...state.flexItemProps];

      q[itemIdq] = {
        ...q[itemIdq],
        flexGrow: action.payload.value
      }
        
      return {
        ...state,
        flexItemProps: q
      }
    case 'flexShrink':
      let itemIdr = action.payload.itemId;

      let r = [...state.flexItemProps];

      r[itemIdr] = {
        ...r[itemIdr],
        flexShrink: action.payload.value
      }
  
      return {
        ...state,
        flexItemProps: r
      }
    case 'flexBasis':
      let itemIds = action.payload.itemId;

      let s = [...state.flexItemProps];

      s[itemIds] = {
        ...s[itemIds],
        flexBasis: action.payload.value
      }
  
      return {
        ...state,
        flexItemProps: s
      }
    case 'align-self':
      let itemIdt = action.payload.itemId;
      
      let t = [...state.flexItemProps];

      t[itemIdt] = {
        ...t[itemIdt],
        alignSelf: action.payload.value
      }

      return {
        ...state,
        flexItemProps: t
      }
    
    case 'FLEX-ITEM-PROP-RESET':
      let itemIdu = action.payload.itemId;
      let u = [ ...state.flexItemProps];

      u[itemIdu] = {
        ...initialFlexItemProps
      }

      return {
        ...state,
        flexItemProps: u
      }
    

    default:
      return state
  }

}


export default globalReducer;